import { registerRenderer } from "../registry.js";
import { renderServiceBookingBlock } from "./service-booking-renderer.js";

registerRenderer("booking-widget", {
  render(props, ctx) {
    return renderServiceBookingBlock(props, ctx, "Book an Appointment");
  },
});
